import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Footer.module.css";
import { Row, Col } from "react-bootstrap";
import logo from "../assets/img/karagroup.png";

const Footer = () => {
  return (
    <div className={styles.wrapper}>
      <Row>
        <Col sm>
          <div>
            <img alt="لوکو" src={logo} className={styles.logo} />
            <p className={styles.alignCenter}>
              شرکت توسعه راهکارهای توزیع شده کارا یک خانواده متشکل از چند تیم
              تخصصی در زمینه‌های فنی و برنامه‌نویسی، تحقیق آموزش و محتوا، مالی و
              دیگر بخش‌های مرتبط می‌باشد که در زمینه توسعه بلاکچین و در سطح
              بین‌المللی در حال فعالیت است.
            </p>
          </div>
        </Col>

        <Col sm className={styles.columnMargin}>
          <h4>تماس باما</h4>
          <p>+0912000000</p>
          <p>support@perseptai.com</p>
          <p>
            تهران ، اتوبان ستاری شمال بالاتر از مجتمع تجاری کوروش ، ساختمان کاخ
          </p>
        </Col>
        <Col sm className={styles.columnMargin}>
          <h4>صفحات</h4>
          <p>خانه</p>
          <p>وبلاگ</p>
          <p>درباره ما</p>
          <p>تماس باما</p>
        </Col>
        <Col sm className={styles.columnMargin}>
          <h4>درباره ما</h4>
          <p>فرصت های شغلی</p>
          <p>سوالات متداول</p>
          <p>حریم خصوصی</p>
          <p>شرایط استفاده</p>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
